webpackJsonp([14],{

/***/ 2120:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(2144),
  /* template */
  __webpack_require__(2181),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_utils_estados_brasileiros__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_leiloes_services_lote_entidade__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_components_popup_viewer_PopupViewer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_components_popup_viewer_PopupViewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__default_components_popup_viewer_PopupViewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_mask__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PopupViewer: __WEBPACK_IMPORTED_MODULE_3__default_components_popup_viewer_PopupViewer___default.a,
    NovoTipoLoteEntidade: function NovoTipoLoteEntidade() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 2179));
    }
  },
  directives: { mask: __WEBPACK_IMPORTED_MODULE_4_v_mask__["a" /* VueMaskDirective */] },
  nome: 'nova-entidade-lote',
  props: {
    entidadeId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      isLoading: false,
      isLoaded: false,
      cadastroError: null,
      atualizadoSucesso: null,
      data: {
        id: null,
        nome: null,
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        estado: null,
        cidade: null,
        bairro: null,
        tipoDocumento: 1,
        documento: null,
        banco: null,
        tipo: null
      },
      tiposDocumento: [{ id: 1, nome: 'CPF' }, { id: 2, nome: 'CNPJ' }],
      tiposEntidade: [],
      showTipoEntidadeForm: false
    };
  },

  computed: {
    estadosBr: function estadosBr() {
      return __WEBPACK_IMPORTED_MODULE_1__default_utils_estados_brasileiros__["a" /* default */];
    }
  },
  created: function created() {
    this.carregarTiposEntidade();
  },
  mounted: function mounted() {
    this.start();
  },
  activated: function activated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    start: function start() {
      var _this = this;

      if (this.entidadeId) {
        this.$parent.loading(true);
        __WEBPACK_IMPORTED_MODULE_2__domain_leiloes_services_lote_entidade__["a" /* default */].findEntidadeLote(this.entidadeId).then(function (response) {
          _this.isLoaded = true;
          _this.data = response.data;
          _this.data.tipo = _this.data.tipo.id;
        }).catch(function (response) {
          console.log(response);
        }).finally(function () {
          _this.$parent.loading(false);
        });
      } else {
        this.isLoaded = true;
      }
    },
    submit: function submit() {
      var _this2 = this;

      this.cadastroError = null;
      this.atualizadoSucesso = false;
      this.$bar.start();
      this.$parent.loading(true);
      __WEBPACK_IMPORTED_MODULE_2__domain_leiloes_services_lote_entidade__["a" /* default */].cadastroEntidadeLote(this.data, this.$route.params.id, this.entidadeId).then(function (response) {
        var callbackEnd = function callbackEnd() {
          _this2.$bar.finish();
          if (_this2.$route.params.id) {
            _this2.start();
            _this2.atualizadoSucesso = true;
            _this2.$el.querySelector('#sucessMsg').focus();
          } else {
            _this2.atualizadoSucesso = true;
          }
          _this2.$emit('finishSubmit');
        };
        callbackEnd();
      }).catch(function (response) {
        _this2.$bar.finish();
        _this2.cadastroError = response.data.errors;
        _this2.$nextTick(function () {
          _this2.$refs.error.focus();
        });
        console.log(response);
      }).finally(function () {
        _this2.$parent.loading(false);
      });
    },
    carregarTiposEntidade: function carregarTiposEntidade() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__domain_leiloes_services_lote_entidade__["a" /* default */].listAllTipoEntidade().then(function (response) {
        _this3.tiposEntidade = response.data;
      }).catch(function (error) {
        _this3.cadastroError = error.data.errors;
      });
    },
    openTipoEntidadeForm: function openTipoEntidadeForm() {
      this.showTipoEntidadeForm = true;
    },
    closeTipoEntidadeForm: function closeTipoEntidadeForm() {
      this.showTipoEntidadeForm = false;
    },
    finishSubmitCadastroTipoEntidade: function finishSubmitCadastroTipoEntidade() {
      this.closeTipoEntidadeForm();
      this.carregarTiposEntidade();
    },
    printError: function printError(err) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isArray"])(err)) {
        return err[0];
      }
      return err;
    }
  }
});

/***/ }),

/***/ 2181:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Gerenciamento de Entidade")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null && _vm.atualizadoSucesso) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.$route.params.id && 'Atualizado' || 'Cadastrado') + " com sucesso!")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "bs-example form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.nome),
      expression: "data.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.cep),
      expression: "data.cep"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##.###-###'),
      expression: "'##.###-###'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.cep)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "cep", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.endereco),
      expression: "data.endereco"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.endereco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "endereco", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Número")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.numero),
      expression: "data.numero"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "numero", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Complemento")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.complemento),
      expression: "data.complemento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.complemento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "complemento", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.estado),
      expression: "data.estado"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "estado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.estadosBr), function(estado) {
    return _c('option', {
      key: estado.sigla,
      domProps: {
        "value": estado.sigla
      }
    }, [_vm._v(_vm._s(estado.nome))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.cidade),
      expression: "data.cidade"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.cidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "cidade", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.bairro),
      expression: "data.bairro"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.bairro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "bairro", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Tipo de Documento")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.tipoDocumento),
      expression: "data.tipoDocumento"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "tipoDocumento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.tiposDocumento), function(tipo) {
    return _c('option', {
      key: tipo.id,
      domProps: {
        "value": tipo.id
      }
    }, [_vm._v(_vm._s(tipo.nome))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "numeroDocumento"
    }
  }, [_vm._v("Número documento")]), _vm._v(" "), (_vm.data.tipoDocumento === 1) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.documento),
      expression: "data.documento"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }],
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "id": "numeroDocumento",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.documento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "documento", $event.target.value)
      }
    }
  })]) : _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.documento),
      expression: "data.documento"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##.###.###/####-##'),
      expression: "'##.###.###/####-##'"
    }],
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "id": "numeroDocumento",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.documento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "documento", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.tipo),
      expression: "data.tipo"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.tiposEntidade), function(tipo) {
    return _c('option', {
      key: tipo.id,
      domProps: {
        "value": tipo.id
      }
    }, [_vm._v(_vm._s(tipo.nome))])
  })], 2), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-xs pull-right m-t-sm m-b-xs m-r-xs btn-default",
    on: {
      "click": _vm.openTipoEntidadeForm
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Cadastrar tipo de entidade\n                  ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs",
    attrs: {
      "type": "submit"
    }
  }, [(!_vm.data.id) ? _c('span', [_vm._v("Cadastrar")]) : _vm._e(), _vm._v(" "), (_vm.data.id) ? _c('span', [_vm._v("Atualizar")]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticClass: "btn m-b-xs w-xs m-r-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("Cancelar")])], 1)])])])]), _vm._v(" "), (_vm.showTipoEntidadeForm) ? _c('popup-viewer', {
    attrs: {
      "title": "Cadastro de Tipo de Entidade"
    },
    on: {
      "close": _vm.closeTipoEntidadeForm
    }
  }, [_c('NovoTipoLoteEntidade', {
    on: {
      "cancel": _vm.closeTipoEntidadeForm,
      "finishSubmit": _vm.finishSubmitCadastroTipoEntidade
    }
  })], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/14.7a49b4f2d61b2218db3e.js